<template>
	<v-layout fill-height column align-center justify-start ma-0>
		<v-scale-transition key = '0' mode = 'in-out' leave-absolute v-show = 'authoption == "google"'>
			<v-card
			  :max-width='$vuetify.breakpoint.smAndUp? "65%": "95%"' :min-width='$vuetify.breakpoint.smAndUp? "65%": "90%"'
			  class = 'ma-auto'
			  v-if = 'authoption == "google"'
			  style = 'background: #fff !important; box-shadow: 0 20px 40px 0 rgba(134, 143, 152, 0.1); border-radius: 10px;'
			>
				<v-layout column class = 'text-xs-center mt-3 mb-2'>
	                <template>
	                    <h1 class = 'font-weight-regular'>Welcome to YetVPN.</h1>
	                </template>
	            </v-layout>
				<v-card-text class = 'px-5 mx-auto' :style = '`width:${$vuetify.breakpoint.smAndUp? "60%": "100%"};`'>
					<v-btn 
                      block depressed large
                      @click.prevent='makeAuthByGoogle()' 
                      :loading = 'authProgress'
                      class='mb-2 mr-2'
                    >
                        <v-icon left small>$vuetify.icons.gcolorized</v-icon>
                        Sign In with Google
                    </v-btn>
					<v-btn 
					  class = 'font-weight-regular' 
					  block 
					  depressed
					  large  
					  @click = 'authoption = "email"'
					>Sign In With Password/Email</v-btn>
					<v-layout 
					  column
					  align-center class = 'mx-auto mt-2' 
					  :style = '"max-width:"+(($vuetify.breakpoint.name == "xs")? "95%;":"60%;")'
					>
						<a href = 'javascript:void(0)' @click = 'authoption = "forgot"' style = 'text-transform: lowercase; color: black;'>Forgot Password?</a>
						<a href = 'javascript:void(0)' :style = '`text-transform: lowercase; color:${$store.getters.accentColor};`' @click = '$router.push("/signup")'>Not registered</a>
					</v-layout>
				</v-card-text>
			</v-card>
		</v-scale-transition>
		<v-scale-transition key = '1' mode = 'in-out' leave-absolute v-show = 'authoption == "email"'>
			<v-card
			  max-width = '75%'
			  min-width = '75%'
			  class = 'ma-auto'
			  v-if = 'authoption == "email"'
			  style = 'background: #fff !important; box-shadow: 0 20px 40px 0 rgba(134, 143, 152, 0.1); border-radius: 10px;'
			>
				<v-layout column class = 'text-xs-center mt-3 mb-2'>
	                <template>
	                    <h1 class = 'font-weight-regular'>Welcome to YetVPN.</h1>
	                </template>
	            </v-layout>
				<v-card-text>
					<v-layout 
					  column d-flex align-center class = 'mx-auto' 
					  :style = '"max-width:"+(($vuetify.breakpoint.name == "xs")? "95%;":"60%;")'
					>
						<v-form class = 'ma-0 pa-0' style = 'width: 100%;'>
							<v-text-field
							  v-model = 'authData.login'
							  class = 'ma-0 pa-0'
							  label = 'Email'
							  autocomplete = 'username'
							  :error = 'error && String(error.code).includes("user")'
		                      :error-messages = '(error && String(error.code).includes("user"))?[error.message]:[]'
		                      outline
							  required
							></v-text-field>
							<v-text-field
							  v-model = 'authData.password'
							  class = 'ma-0 pa-0'
							  label = 'Password'
							  autocomplete = 'user-password'
							  :append-icon = "showPassword ? 'mdi-eye-off-outline' : 'mdi-eye-outline'"
		                      @click:append = "showPassword = !showPassword"
		                      :type = "showPassword ? 'text' : 'password'"
		                      :error = 'error && String(error.code).includes("password")'
		                      :error-messages = '(error && String(error.code).includes("password"))?[error.message]:[]'
		                      outline
							  required
							></v-text-field>
							<v-btn 
							  class = 'pt-0 mt-0 white--text mb-2'
							  large
							  block 
							  depressed 
							  ripple
							  @click = 'makeAuthByPwd(authData.login, authData.password)'
							  color = 'red lighten-1'
							  :loading = 'authProgress'
							>Sign In</v-btn>
							<v-btn class = 'pa-0 ma-0 font-weight-regular' block depressed large ripple @click = 'authoption = "google"; authProgress = false;'>Sign In With Google Account</v-btn>
						</v-form>
					</v-layout>
					<v-layout 
					  column
					  align-center class = 'mx-auto mt-2' 
					  :style = '"max-width:"+(($vuetify.breakpoint.name == "xs")? "95%;":"60%;")'
					>
						<a href = 'javascript:void(0)' @click = 'authoption = "forgot"' style = 'text-transform: lowercase; color: black;'>Forgot Password?</a>
						<a href = 'javascript:void(0)' :style = '`text-transform: lowercase; color:${$store.getters.accentColor};`' @click = '$router.push("/signup")'>Not registered</a>
					</v-layout>
				</v-card-text>
			</v-card>
		</v-scale-transition>
		<v-scale-transition key = '2' mode = 'in-out' leave-absolute v-show = 'authoption == "forgot"'>
			<v-card
			  max-width = '75%'
			  min-width = '75%'
			  class = 'ma-auto'
			  v-if = 'authoption == "forgot"'
			  style = 'background: #fff !important; box-shadow: 0 20px 40px 0 rgba(134, 143, 152, 0.1); border-radius: 10px;'
			>
				<v-layout column class = 'text-xs-center mt-3 mb-2'>
	                <template>
	                    <h1 class = 'font-weight-regular'>Welcome to YetVPN.</h1>
	                </template>
	            </v-layout>
				<v-card-text>
					<v-layout 
					  column d-flex align-center class = 'mx-auto' 
					  :style = '"max-width:"+(($vuetify.breakpoint.name == "xs")? "95%;":"60%;")'
					>
						<v-form class = 'ma-0 mx-0 pa-0' style = 'width: 100%;'>
							<v-text-field
							  v-model = 'authData.login'
							  class = 'ma-0 pa-0'
							  label = 'Email'
							  autocomplete = 'username'
							  required
							></v-text-field>
							<v-btn class = 'pt-0 mt-0 white--text mb-2' color = 'red lighten-1' large block depressed ripple @click = 'sendPasswordResetEmail()'>Restore Password</v-btn>
							<v-btn class = 'pa-0 ma-0 font-weight-regular mb-2' block depressed large ripple @click = 'authoption = "google"'>Sign In With Google Account</v-btn>
							<v-btn class = 'pa-0 ma-0 font-weight-regular' block depressed large ripple @click = 'authoption = "email"'>Sign In With Password/Email</v-btn>
						</v-form>
					</v-layout>
					<v-layout 
					  column
					  align-center class = 'mx-auto mt-2' 
					  :style = '"max-width:"+(($vuetify.breakpoint.name == "xs")? "95%;":"60%;")'
					>
						<a href = 'javascript:void(0)' :style = '`text-transform: lowercase; color:${$store.getters.accentColor};`' @click = '$router.push("/signup")'>Not registered</a>
					</v-layout>
				</v-card-text>
			</v-card>
		</v-scale-transition>
		<v-scale-transition key = '3' mode = 'in-out' leave-absolute v-show = 'authoption == "forgot"'>
			<v-card
			  max-width = '75%'
			  min-width = '75%'
			  class = 'ma-auto'
			  v-if = 'authoption == "restore"'
			  style = 'background: #fff !important; box-shadow: 0 20px 40px 0 rgba(134, 143, 152, 0.1); border-radius: 10px;'
			>
				<v-card-text>
					<v-layout 
					  column align-center class = 'mx-auto' 
					  :style = '"max-width:"+(($vuetify.breakpoint.name == "xs")? "95%;":"60%;")'
					>
						<span class = 'title font-weight-light text-xs-center mb-2'>Welcome aboard!</span>
					</v-layout>
					<v-layout 
					  column d-flex align-center class = 'mx-auto' 
					  :style = '"max-width:"+(($vuetify.breakpoint.name == "xs")? "95%;":"60%;")'
					>
						<v-btn 
			  			  block
			  			  depressed 
			  			  outline
			  			  color = 'blue darken-4' 
			  			  @click.prevent = 'newPassword = generateSecureString(12); showPassword = true; validPassword = true;errorPassword = false;' 
			  			  class = 'mb-3'
			  			>Generate secure password</v-btn>
			  			<v-form v-model = 'validPassword' class = 'ma-0 pa-0' style = 'width: 100%;'>
			  				<v-text-field
				  			  :rules = "[rules.password]"
				  			  label = "Password"
				  			  v-model = 'newPassword'
				  			  :append-icon="showPassword ? 'visibility_off' : 'visibility'"
				  			  @click:append="showPassword = !showPassword"
				  			  :type="showPassword ? 'text' : 'password'"
				  			  :error='errorPassword'
		                      :error-messages='errorPasswordMessage'
		                      @keyup='errorPassword=false;errorPasswordMessage=[];'
				  			  validate-on-blur
				  			  outline
				  			></v-text-field>
				  			<v-btn class = 'pt-0 mt-0 white--text' color = 'red lighten-1' large block depressed ripple round @click = 'confirmNewPasswordByCode(restoreCode)'>Set Password</v-btn>
				  			<v-btn class = 'pa-0 ma-0 font-weight-regular' block flat small ripple round @click = 'authoption = "google"'>Sign In With Google Account</v-btn>
							<v-btn class = 'pa-0 ma-0 font-weight-regular' block flat small ripple round @click = 'authoption = "email"'>Sign In With Password/Email</v-btn>
			  			</v-form>
					</v-layout>
					<v-layout 
					  column
					  align-center class = 'mx-auto mt-2' 
					  :style = '"max-width:"+(($vuetify.breakpoint.name == "xs")? "95%;":"60%;")'
					>
						<a href = 'javascript:void(0)' :style = '`text-transform: lowercase; color:${$store.getters.accentColor};`' @click = '$router.push("/signup")'>Not registered</a>
					</v-layout>
				</v-card-text>
			</v-card>
		</v-scale-transition>
		<v-alert :value = '$store.state.errorLogin' dismissible transition = "scale-transition" type = 'error' style = 'width: 100%;'>Login not found. Plese refer to <a href="javascript:void(0)" @click = '$router.push("/signup")'>register page</a> or try to use another account.</v-alert>
	</v-layout>
</template>

<script>
	import firebase from 'firebase/app'
	import 'firebase/auth'
	import 'firebase/firestore'
	import aeng from '@/components/auth_engine'

	export default {
		path: '/signin',
		name: 'Signin',
		mixins: [aeng],
		methods: {
			confirmNewPasswordByCode(code) {
				firebase.auth().confirmPasswordReset(code, this.newPassword).then( () => {
					this.authoption = "email";
					this.authData.password = this.newPassword;
				}).catch( (err) => {
					let errorCode = err.code;
					let errorMessage = err.message;
					if (errorCode == 'auth/user-disabled') {
						this.errorPassword = true;
						this.errorPasswordMessage = 'Sorry, but user account has been disabled';
					}
					if (errorCode == 'auth/user-not-found') {
						this.errorPassword = true;
						this.errorPasswordMessage = 'Sorry, but user account not found';
					}
					if (errorCode == 'auth/expired-action-code') {
						this.errorPassword = true;
						this.errorPasswordMessage = 'Reset link has been expired'
					}
					if (errorCode == 'auth/weak-password') {
						this.errorPassword = true;
						this.errorPasswordMessage = 'Provided password is too weak. Please provide more secure string.'
					}
				});
			},
			sendPasswordResetEmail() {
				firebase.auth().sendPasswordResetEmail(this.authData.login).then( () => {
					this.authoption = "email";
					this.authProgress = false;
				}).catch( (err) => {
					console.log(err)
				})
			}
		},
		data() {
			return {
				authData: {},
				authoption: 'google',
				showPassword: false,
				newPassword: '',
				validPassword: false,
				errorPassword: false,
				errorPasswordMessage: '',
				restoreCode: ''
			}
		},
		mounted() {
			if (Object.keys(this.$route.query).includes('mode') && Object.keys(this.$route.query).includes('oobCode')) {
				if (this.$route.query.mode == 'resetPassword') {
					this.restoreCode = this.$route.query.oobCode;
					this.authoption = 'restore';
				}
			}
		}
	}
</script>